import {
  type FC,
  useCallback,
} from 'react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { AppModalRendererComponent } from '~/modal/appModalRendererComponent';
import { closeModal } from '~/store/modal/modal.actionCreators';
import { useModalStackSelector } from '~/store/modal/modal.selectors';

/***
 * Don't use this component. It should be rendered once in the app.
 */
export const AppModalRendererContainer: FC = () => {
  const dispatch = useDispatch();
  const modalStack = useModalStackSelector();
  const openedModal = modalStack[modalStack.length - 1];

  const onClose = useCallback((id: string) => {
    const modal = modalStack.find(modal => modal.id === id);

    if (!modal) {
      return;
    }

    modal.typeWithArgs?.[1]?.onClose?.();

    return dispatch(closeModal(id));
  }, [dispatch, modalStack]);

  if (!openedModal) {
    return null;
  }

  return (
    <>
      {modalStack.map(modal => {
        return (
          <AppModalRendererComponent
            key={modal.id}
            id={modal.id}
            isOpen={modal === openedModal}
            onClose={onClose}
            parameters={modal.typeWithArgs}
          />
        );
      })}
    </>
  );
};
